import { getField, updateField } from 'vuex-map-fields';


const state = () => ({
    show_contract: false,
    show_policy_privacity: false,
    show_data_treatment: false,
    show_ai_system_transparency: false,
});


const mutations = {
    SHOW_CONTRACT: (state) => {
        state.show_contract = true;
    },
    HIDE_CONTRACT: (state) => {
        state.show_contract = false;
    },
    SHOW_POLICY_PRIVACITY: (state, show) => {
        state.show_policy_privacity = show;
    },
    HIDE_POLICY_PRIVACITY: (state, show) => {
        state.show_policy_privacity = false ;
    },
    SHOW_DATA_TREATMENT: (state, show) => {
        state.show_data_treatment = show;
    },
    HIDE_DATA_TREATMENT: (state, show) => {
        state.show_data_treatment = false ;
    },
    SHOW_AI_SYSTEM_TRANSPARENCY: (state, show) => {
        state.show_ai_system_transparency = show;
    },
    HIDE_AI_SYSTEM_TRANSPARENCY: (state, show) => {
        state.show_ai_system_transparency = false;
    },
    updateField,
};


const getters = {
    show_contract: state => state.show_contract,
    show_policy_privacity: state => state.show_policy_privacity,
    show_data_treatment: state => state.show_data_treatment,
    show_ai_system_transparency: state => state.show_ai_system_transparency,
    getField
}


const showContract = ({ commit }) => {
    commit('SHOW_CONTRACT', true);
}

const hideContract = ({commit}) => {
    commit('HIDE_CONTRACT', false);
}

const showPolicyPrivacity = ({ commit }) => {
    commit('SHOW_POLICY_PRIVACITY', true);
}

const hidePolicyPrivacity = ({commit}) => {
    commit('SHOW_POLICY_PRIVACITY', false);
}

const showDataTreatment = ({ commit }) => {
    commit('SHOW_DATA_TREATMENT', true);
}

const hideDataTreatment = ({commit}) => {
    commit('SHOW_DATA_TREATMENT', false);
}

const showAISystemTransparency = ({ commit }) => {
    commit('SHOW_AI_SYSTEM_TRANSPARENCY', true);
}

const hideAISystemTransparency = ({commit}) => {
    commit('SHOW_AI_SYSTEM_TRANSPARENCY', false);
}

const printContract = ({commit}) => {
    let dialog = document.getElementsByClassName('v-dialog--active')
    if (dialog[0]) {
        dialog[0].style.position = 'static';
        dialog[0].style.boxShadow = 'none';
    }
    let application  = document.getElementsByClassName('v-application--wrap');
    if (application[0]) {
        application[0].style.display = 'none';
    }
    window.print()
    if (dialog[0]) {
        dialog[0].style.position = 'fixed';
    }
    if (application[0]) {
        application[0].style.display = 'flex';
    }
}

const actions = {
    showContract,
    hideContract,
    showPolicyPrivacity,
    hidePolicyPrivacity,
    showDataTreatment,
    hideDataTreatment,
    showAISystemTransparency,
    hideAISystemTransparency,
    printContract
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}